"use client";

import { useEffect } from "react";
import AppErrorView from "@/app/components/AppErrorView";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log exception to console in dev / monitoring
    console.error("Unhandled runtime application error:", error);
  }, [error]);

  return <AppErrorView statusCode={500} error={error} reset={reset} />;
}
